import React from 'react';
import { trackResultClick } from '../suggest/tracking';
import { ResultGroup } from './ResultGroup';
import { ResultOption } from './ResultOption';
import type { ActionFunction, ResultsProps } from './ResultTypes';
import { SelectAction } from './ResultTypes';

export const popularSearchResultsAction: ActionFunction = ({
    metaData,
    result,
}) => {
    trackResultClick(result, metaData.tracking);
    window.location.href = result.url;
    return SelectAction.CLOSE;
};

export function PopularSearchResults(props: ResultsProps) {
    const { headingClass, resultGroup } = props;

    const resultId = React.useId();

    return (
        <ResultGroup
            heading={resultGroup.groupingHeader}
            headingClass={headingClass}
        >
            <div className="flex flex-wrap">
                {resultGroup.results.map((result) => (
                    <ResultOption
                        className="mr-8 mb-8"
                        key={`${result.resultType}-${result.order}-${resultId}`}
                        result={result}
                    >
                        {({ active, ariaLabel }) => (
                            <a
                                aria-label={ariaLabel}
                                className={`link link--dark inline-block px-20 py-8 bg-bluegray-100 rounded-full text-14 border ${
                                    active
                                        ? 'border-bluegray-300'
                                        : 'border-transparent'
                                }`}
                            >
                                {result.title}
                            </a>
                        )}
                    </ResultOption>
                ))}
            </div>
        </ResultGroup>
    );
}
